




import { Vue, Component, Prop } from 'vue-property-decorator'
import Survey from '@/components/Survey.vue'

@Component({
  components: {
    Survey
  }
})
export default class Home extends Vue {
  @Prop(String) step!: string | undefined
  @Prop(String) token!: string | undefined

  get currentStep() {
    return this.step ? parseInt(this.step) : 1
  }
}
